import { useEffect } from "react";
import { useWS } from "../context/WebSocketContext";

/** Reload bootstrap when any of the given WS entity types fire. */
export function useBootstrapWS(wsTypes, reload) {
  const { subscribe } = useWS();
  useEffect(() => {
    if (!reload || !wsTypes?.length) return undefined;
    const unsubs = wsTypes.map((type) => subscribe(type, reload));
    return () => unsubs.forEach((u) => u());
  }, [subscribe, reload, wsTypes]);
}
